'use client';

import { SupplierRequestMatch } from '@scaleup/models';
import { useRouter } from 'next/navigation';
import {
  useAcceptDeclineSrmMutation,
  useGetSrMatchesQuery,
  useGetSupplierQuery,
} from '../../api';
import { useAlert } from '../../hooks';
import { Button, Loading, SupplierAvatar } from '../../ui';

export const SupplierCard = ({
  supplierRequestMatch,
}: {
  supplierRequestMatch: SupplierRequestMatch;
}) => {
  const setAlert = useAlert();
  const router = useRouter();
  const [acceptDeclineSrm, { isLoading: acceptDeclineSrmLoading }] =
    useAcceptDeclineSrmMutation();

  const { refetch: refetchSrMatches } = useGetSrMatchesQuery(
    supplierRequestMatch.requestId
  );

  const { data: supplier, isLoading: supplierLoading } = useGetSupplierQuery(
    supplierRequestMatch.orgId
  );

  const handleAcceptDecline = async (accept: boolean) => {
    await acceptDeclineSrm({
      id: supplierRequestMatch.requestId,
      matchId: supplierRequestMatch.matchId,
      accept,
    });
    await refetchSrMatches();
    if (accept) {
      setAlert({
        title: 'Supplier accepted',
        message: 'Supplier accepted successfully',
        severity: 'success',
        show: true,
      });
    } else {
      setAlert({
        title: 'Supplier decline',
        message: 'Supplier declined successfully',
        severity: 'success',
        show: true,
      });
    }
  };

  return (
    <>
      <Loading size="lg" loading={supplierLoading}>
        <div className="flex-1 rounded-[2rem] bg-white flex flex-col justify-between">
          <div className="py-[4rem] px-[2rem] flex flex-col gap-4">
            <SupplierAvatar supplierId={supplierRequestMatch.orgId} />
            <span className="text-2xl font-bold">
              {supplierRequestMatch.orgName}
            </span>
            <span>{supplier?.supplierData.description}</span>
            <Button
              text="View Profile"
              variant="link"
              onClick={() => {
                router.push(`/supplier-profile/${supplierRequestMatch.orgId}`);
              }}
              suffixIcon="/icons/arrow_right-primary500.svg"
            />
          </div>
          <div className="flex gap-2 shadow-top p-8 rounded-b-[32px]">
            <button
              className="border border-primary-600 text-primary-600 font-bold rounded-full px-4 py-3 flex-1"
              onClick={handleAcceptDecline.bind(null, false)}
              disabled={acceptDeclineSrmLoading || supplierLoading}
            >
              Not the right fit
            </button>
            <button
              className="font-bold bg-gradient-to-r from-[#4AAECA] from-0% to-[#4EB3CF] to-100% text-white rounded-full px-4 py-3 flex-1"
              onClick={handleAcceptDecline.bind(null, true)}
              disabled={acceptDeclineSrmLoading || supplierLoading}
            >
              &#10004; Accept
            </button>
          </div>
        </div>
      </Loading>
    </>
  );
};
